export const LE_AGENT_HUB_SIGNUP_ROUTE = '/agent-hub/signup'
export const LE_AGENT_HUB_COMPLETE_ACCOUNT_SETUP = '/agent-hub/complete-account-setup'
export const LE_AGENT_HUB_ACCOUNT_SETUP_COMPLETED = '/agent-hub/account-setup-completed'
